// extracted by mini-css-extract-plugin
export default {"indicator-bar":"R6zQpHd","indicator-bar__progress":"gtRsklQ","indicator-bar__triangle":"vOEUm4A"};